var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "0 0 64 64",
    width: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.223 14.981 33.626 33.625h2.823l-35.032-35.042z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.272 12.272h10v4h-10z",
    transform: "matrix(.707 -.707 .707 .707 -5.912 14.272)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.251 26.357c.017-.02.023-.045.042-.064l4-4a1 1 0 0 1 1.414 1.414l-4 4c-.019.019-.044.025-.064.042l2.837 2.837 2.42-2.423a5.061 5.061 0 0 1 4.1-1.5 11.011 11.011 0 0 0 12.218-11.977l-6 6a1 1 0 0 1 -.905.273l-7.069-1.419a1 1 0 0 1 -.783-.784l-1.421-7.069a1 1 0 0 1 .273-.905l6-6a11.011 11.011 0 0 0 -11.98 12.218 5.057 5.057 0 0 1 -1.5 4.1l-2.419 2.42z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.749 37.644c-.017.019-.023.044-.042.063l-4 4a1 1 0 0 1 -1.414-1.414l4-4c.019-.019.044-.025.063-.042l-2.836-2.837-2.42 2.423a5.047 5.047 0 0 1 -4.1 1.5 11.011 11.011 0 0 0 -12.218 11.977l6-6a1 1 0 0 1 .9-.273l7.07 1.419a1 1 0 0 1 .783.784l1.421 7.069a1 1 0 0 1 -.274.905l-6 6a11.011 11.011 0 0 0 11.985-12.218 5.057 5.057 0 0 1 1.5-4.1l2.423-2.423z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.322 4.322a5 5 0 0 0 -3.535 8.536l2.121 2.121 7.071-7.071-2.121-2.121a4.965 4.965 0 0 0 -3.536-1.465z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.269 54.448-.961-3.842h-3.654l.469 2.34a1 1 0 0 1 -1.177 1.177l-2.34-.468v3.653l3.843.962a6.926 6.926 0 0 1 3.82-3.822z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.764 56.424a4.779 4.779 0 0 0 -2.34 2.34l3.121.781z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.867 51.867-.354-1.768-33.704-33.704-1.414 1.414 33.704 33.705z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.606 52.849-33.625-33.626-1.417 1.417 35.042 35.032z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.1e27e7de.svg";
export { ForwardRef as ReactComponent };